<div class="toggle-wrapper">
    <div class="left">
        {{description}}
    </div>
    <div class="right">
       <app-base-toggle-switch [checked]="checked" (toggled)="onToggle()" [disabled]="disabled"></app-base-toggle-switch>
    </div>
</div>